import { NavLink } from "react-router-dom"
import { useAuthStore } from "store/store"
import styled from "styled-components"


//========================== To add a protected Route that only admins can access this page================

const UserMenu=()=>{
    // const {auth}=useAuthStore();
    const { auth } = useAuthStore();
      const logout=useAuthStore(state=>state.logout);
    return(
        <Wrapper>
            <div>
            <h3>User</h3>
            <ul className="side-menu">
                <li className="side-menu-li">
                    <NavLink to='/dashboard'>Dashboard</NavLink>
                </li>
                <li className="side-menu-li">
                    <NavLink to='/profile'>Profile</NavLink>
                </li>
                 <li className="side-menu-li">
                    <NavLink to="/orders">My Orders</NavLink>
                </li >
                <li className="side-menu-li">
                    <NavLink to="/UserAddressList">Address List</NavLink>
                </li >
                <li className="side-menu-li">
                    <NavLink to="/address">Create Address</NavLink>
                </li >
                 <li className="side-menu-li">
                    <NavLink to="/reset">Reset Passward</NavLink>
                </li >
                <li className="side-menu-li">
                    <NavLink onClick={logout} to='/'>Logout</NavLink>
                </li >
                
            </ul>
            </div>
        </Wrapper>
    )
}
const Wrapper=styled.div`
height: auto;
padding:2rem 0rem;
background: ${({ theme }) => theme.colors.bgl};
text-transform:uppercase;

/* Slide-in effect */
  animation: slideIn 1s ease-out forwards;

  @keyframes slideIn {
    from {
      transform: translateX(-100%); /* start hidden to the left */
      opacity: 0;
    }
    to {
      transform: translateX(0); /* slide into place */
      opacity: 1;
    }
  }

h3  {
    padding:1rem ;
    text-align: center;
    font-size: 2.5rem;
    }

.side-menu{
    padding:4rem; 
    }

li{
 padding:2rem;
 font-size: 1.6rem; 
 font-weight: 450;
 border-bottom: 1px solid black;
 cursor:pointer;
 
 &:hover{
  background:${({ theme }) => theme.colors.bgl};
 }

 a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.text};
    display: block; 
   }

a.active {
    color:${({ theme }) => theme.colors.helper};
    }
}
 
@media (max-width: ${({ theme }) => theme.media.mobile}) {
 display: none;
  }
`;


export default UserMenu